import styled from "styled-components";

export const ChangePasswordContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 50%;
`;

export const InputContainer = styled.div`
    width: calc(100% - 184px);
`;

export const NewPasswordInputContainer = styled.div`
    width: calc(100% - 184px);
    min-width: 200px;
`;

export const PasswordStrengthContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StrengthBarContainer = styled.div`
    margin-top: 8px;
    height: 10px;
    width: 160px;
    background: #eee;
    border-radius: 5px;
    overflow: hidden;
`;

export const StrengthBar = styled.div`
    height: 100%;
    width: ${props => props.width}%;
    background: ${props => {
        const colors = ['red', 'orange', 'yellow', 'lightgreen', 'green'];
        const activeColors = colors.slice(0, props.score);
        return activeColors.length > 1 
            ? `linear-gradient(to right, ${activeColors.join(', ')})`
            : activeColors[0] || 'red';
    }};
    transition: width 0.3s ease;
`;

export const StrengthTooltip = styled.div`
    position: absolute;
    top: 120%;
    right: 0;
    padding: 8px;
    z-index: 10;
    width: 160px;
`;

export const StrengthList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const StrengthListItem = styled.li`
    color: ${props => props.isValid ? 'lightgreen' : 'white'};
`;

export const PasswordMatchContainer = styled.div`
    margin-top: 5px;
`;

export const PasswordMatchText = styled.h5`
    color: ${props => props.isMatch ? 'green' : 'red'};
`;

export const StrengthInfoContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const InfoIcon = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #666;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    cursor: help;
    position: relative;
    
    &:hover {
        background: #333;
    }
`;

